import { useContext, useEffect } from 'react';
import { getWebInstrumentations, initializeFaro } from '@grafana/faro-react';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';
import { OneLPSsdkParamsContext } from '../../onelps-sdk-params-context';

function FaroComponent() {
	const onelpsParams = useContext(OneLPSsdkParamsContext);

	useEffect(() => {
		initializeFaro({
			url: onelpsParams.faro.config.url,
			apiKey: onelpsParams.faro.config.apiKey,
			app: {
				name: 'onelps',
				version: '1.0.0',
			},
			user: {
				attributes: {
					market_id: onelpsParams.marketId,
					game_id: onelpsParams.gameId,
				},
			},
			ignoreUrls: onelpsParams.faro.config.ignoreUrls,
			batching: {
				enabled: onelpsParams.faro.config.batchingEnabled,
				sendTimeout: 1000,
				itemLimit: onelpsParams.faro.config.batchingItemLimit,
			},
			instrumentations: [
				...getWebInstrumentations(),
				new TracingInstrumentation(),
			],
		});

	}, [
		onelpsParams.marketId,
		onelpsParams.gameId,
		onelpsParams.faro.config.url,
		onelpsParams.faro.config.apiKey,
		onelpsParams.faro.config.ignoreUrls,
		onelpsParams.faro.config.batchingEnabled,
		onelpsParams.faro.config.batchingItemLimit
	]);

	return null;
}

export default FaroComponent;